import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { blueprintsUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import navigateTo from "@src/routes/navigator";
import { Route } from "@src/routes/routes";

export interface FetchSelectedBlueprintDto {
  namespace: string;
  blueprintUuid: string;
}

export const fetchSelectedBlueprint = async (
  dto: FetchSelectedBlueprintDto,
) => {
  const url = blueprintsUrlEnvVar();
  return axios
    .get(`${url}/api/v3/ns/${dto.namespace}/blueprints/${dto.blueprintUuid}`, {
      headers: buildAxiosAuthenticationHeaders(),
    })
    .then((response) => response.data)
    .then((data) => {
      if (data !== undefined) {
        return data;
      }
    })
    .catch((err) => {
      if (err?.response?.data?.message === "Refresh Token is expired") {
        navigateTo(Route.TOKENS_EXPIRED_ERROR);
      } else {
        navigateTo(Route.SERVER_ERROR);
      }
    });
};
